const warningOmissionsStorageKey = "warningOmissions";

export const loadWarningOmissions = () => {
  try {
    const serializedState = localStorage.getItem(warningOmissionsStorageKey);
    if (serializedState === null) {
      return [];
    }
    return JSON.parse(serializedState);
  } catch (err) {
    console.error(err);
    return [];
  }
};

export const storeWarningOmissions = (_oldMetadata, newMetaData) => {
  try {
    const serializesState = JSON.stringify(newMetaData);
    localStorage.setItem(warningOmissionsStorageKey, serializesState);
  } catch (err) {
    console.error(err);
  }
};
